// Este archivo usa ES6 modules pero también accede a module.hot (Webpack HMR API)
// El linter detecta module.hot y asume CommonJS, pero es un falso positivo
/* eslint-disable */
import { configureStore } from '@reduxjs/toolkit';
import { fieldValuesSlice } from './fieldValues';
import { flowStrategySlice } from './flowStrategy';
import { creditConditionsSlice } from './creditConditions';
import { nodesFieldsSlice } from './nodesFields';
import { perfiladorSlice } from './perfilador';

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

export const store = configureStore({
  reducer: {
    fieldValues: fieldValuesSlice.reducer,
    flowStrategy: flowStrategySlice.reducer,
    creditConditions: creditConditionsSlice.reducer,
    nodesFields: nodesFieldsSlice.reducer,
    perfilador: perfiladorSlice.reducer,
  },
  devTools: ENVIRONMENT === 'development',
});

// Hot Module Replacement para preservar estado del perfilador en desarrollo
if (process.env.NODE_ENV === 'development' && typeof module !== 'undefined' && module.hot) {
  module.hot.accept('./perfilador', () => {
    // Reemplazar solo el reducer del perfilador sin perder el estado actual
    store.replaceReducer({
      // fieldValues: fieldValuesSlice.reducer,
      // flowStrategy: flowStrategySlice.reducer,
      // nodesFields: nodesFieldsSlice.reducer,
      creditConditions: creditConditionsSlice.reducer,
      perfilador: perfiladorSlice.reducer,
    });
  });
}
